import {
  CheckBolderIcon,
  Icon,
  LockIcon,
  SidebarDivider,
} from '@equifinance/shared';
import { useTabNavHeight } from '../AccountTabNav';
import ProductSidebarHeader from '../Products/ProductSidebar/ProductSidebarHeader';
import { IconCircleSmall, SectionSidebarItem } from '../Sidebar';
import { useAccountContext } from '../../contexts';
import { TaskSectionTitleIcon } from './sections/TaskSection';
import { useTasksContext } from '../../contexts/tasks';
import CrossIcon from '../Account/Icons/CrossIcon';

export enum TasksRefNames {
  TASKS = 'tasks',
  DOCUMENT_UPLOAD = 'document-upload',
  RESOURCES = 'resources',
}

export default function TasksSidebar() {
  const stickyHeaderOffset = useTabNavHeight();
  const { account } = useAccountContext();
  const { tasks } = useTasksContext();

  return (
    <>
      <ProductSidebarHeader />

      <SidebarDivider />

      <SectionSidebarItem
        stickyHeaderOffset={stickyHeaderOffset}
        refName={TasksRefNames.RESOURCES}
        icon={<Icon size="17px" className="mi-document" />}
        key="resources-sidebar-item"
      >
        Resources
      </SectionSidebarItem>

      <SectionSidebarItem
        stickyHeaderOffset={stickyHeaderOffset}
        refName={TasksRefNames.TASKS}
        icon={(
          <TaskSectionTitleIcon
            tasks={tasks.tasks}
            applicationStatus={account.status}
            tickIcon={(
              <IconCircleSmall>
                <CheckBolderIcon />
              </IconCircleSmall>
            )}
            crossIcon={<CrossIcon size={17} />}
            lockIcon={<LockIcon small />}
          />
        )}
        key="tasks-sidebar-item"
      >
        Tasks
      </SectionSidebarItem>

    </>
  );
}
